// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/watcher/[picId]/[carId]/page"
import { usePageHead } from "../../../../compat/head"

export const Route = createFileRoute("/watcher/$picId/$carId/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Tắt lúc ${new Date(h.offAt).toLocaleString(" })
  const params = Route.useParams()
  const search = Route.useSearch()
  const pageProps: any = { params: Promise.resolve(params), searchParams: Promise.resolve(search) }
  return <Page {...pageProps} />
}
